import btnGroup from './btn-group.vue';
btnGroup.install = Vue => Vue.component(btnGroup.name,btnGroup);
export default btnGroup;



// WEBPACK FOOTER //
// ./src/packages/button/btn-group/index.js